module.exports = __webpack_public_path__ + "img/p2-66.b1c15e83.png";